import { render, staticRenderFns } from "./pictureDetail.vue?vue&type=template&id=290d2700&"
import script from "./pictureDetail.vue?vue&type=script&lang=js&"
export * from "./pictureDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports